"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
require("../icon-button");
//@ts-ignore
require("../theme.ts");
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.btnClick = function (evt, index) {
            _this.fire('buttonaction', { index: index, target: evt.currentTarget });
        };
        _this.iconClick = function (evt, index) {
            _this.fire('iconaction', { index: index, target: evt.currentTarget, isOn: evt.detail.isOn });
        };
        return _this;
    }
    Card.prototype.render = function (props) {
        var _this = this;
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-card', {
            'over-img': props.overImg,
            'top-title': props.topTitle
        }), { style: "width:" + (props.width || '640px;') }),
            props.topTitle && omi_1.h("div", { class: "mdc-card__primary" },
                omi_1.h("h2", { class: "mdc-typography mdc-typography--headline6" }, props.title),
                props.subTitle && omi_1.h("h3", { class: "mdc-typography mdc-typography--subtitle2" }, props.subTitle)),
            omi_1.h("div", { class: "mdc-card__primary-action  mdc-ripple-upgraded", tabindex: "0" },
                props.img && omi_1.h("div", { class: "mdc-card__media mdc-card__media--16-9", style: "background-image: url(" + props.img + ");" }, props.overImg && !props.topTitle && omi_1.h("div", { class: "mdc-card__primary" },
                    omi_1.h("h2", { class: "mdc-typography mdc-typography--headline6" }, props.title),
                    props.subTitle && omi_1.h("h3", { class: "mdc-typography mdc-typography--subtitle2" }, props.subTitle))),
                !props.overImg && !props.topTitle && omi_1.h("div", { class: "mdc-card__primary" },
                    omi_1.h("h2", { class: "mdc-typography mdc-typography--headline6" }, props.title),
                    props.subTitle && omi_1.h("h3", { class: "mdc-typography mdc-typography--subtitle2" }, props.subTitle)),
                omi_1.h("div", { class: "mdc-card__secondary mdc-typography mdc-typography--body2" }, props.content)),
            (props.buttons || props.icons) && omi_1.h("div", { class: "mdc-card__actions" },
                props.buttons && omi_1.h("div", { class: "mdc-card__action-buttons" }, props.buttons.map(function (btn, index) { return omi_1.h("button", { onClick: function (_) { return _this.btnClick(_, index); }, class: "mdc-button mdc-card__action mdc-card__action--button mdc-ripple-upgraded" }, btn); })),
                props.icons && omi_1.h("div", { class: "mdc-card__action-icons" }, props.icons.map(function (icon, index) {
                    if (typeof icon === 'string')
                        return omi_1.h("m-icon-button", { onClick: function (_) { return _this.iconClick(_, index); }, icon: icon });
                    return omi_1.h("m-icon-button", { onChange: function (_) { return _this.iconClick(_, index); }, icons: icon });
                })))));
    };
    Card.css = css;
    Card.propTypes = {
        width: String,
        img: String,
        title: String,
        subTitle: String,
        content: String,
        buttons: Object,
        icons: Object,
        topTitle: Boolean,
        overImg: Boolean
    };
    Card = __decorate([
        omi_1.tag('m-card')
    ], Card);
    return Card;
}(omi_1.WeElement));
exports.default = Card;
